import { useLazyQuery } from "@apollo/client/react";
import { useSchedulerState } from "hooks/state";
import useTimeZone from "hooks/useTimeZone";
import { GetShiftInstanceByRange } from "./shiftInstance.gql";

export default function useFetchShiftInstances() {
  const {
    state: { dataTimeRange },
  } = useSchedulerState();
  const { overrideToSiteTimeZone } = useTimeZone();

  const [getShiftInstances, { data, loading, error, fetchMore }] = useLazyQuery(GetShiftInstanceByRange, {});

  return {
    data,
    error,
    loading,
    refetch: ({ dataTimeRange: newDataTimeRange } = {}) => {
      const actualStart = newDataTimeRange?.startDate || dataTimeRange.startDate;
      const actualEnd = newDataTimeRange?.endDate || dataTimeRange.endDate;
      const variables = {
        scheduledEnd: overrideToSiteTimeZone(actualEnd),
        scheduledStart: overrideToSiteTimeZone(actualStart),
      };

      if (data) {
        return fetchMore({
          variables: variables,
        });
      }
      return getShiftInstances({ variables: variables });
    },
    shiftInstances: data ? data.shiftInstances : [],
  };
}
